import { NodeViewContent } from '@tiptap/react';
import React, { useContext } from 'react';

import { RicosTiptapContext } from '../context';
import styles from '../statics/styles/tiptap-editor-styles.scss';
import { ErrorBoundary } from './ErrorBoundary';

export const RicosNode = ({ Component, tiptapNodeProps }) => {
  const ricosTiptapContext = useContext(RicosTiptapContext) || {};

  const componentProps = {
    ...ricosTiptapContext, // helpers, editor Props
    componentData: tiptapNodeProps.node.attrs,
    ...tiptapNodeProps,
    NodeViewContent,
  };

  if (!ricosTiptapContext.context.t) {
    return null;
  }

  return (
    <div
      data-hook={`ricos-node editor-${tiptapNodeProps.node.attrs.id}`}
      className={styles['ricos-node']}
    >
      <ErrorBoundary t={ricosTiptapContext.context.t}>
        <Component {...componentProps} />
      </ErrorBoundary>
    </div>
  );
};
